import { useEffect } from 'react'
import Header from '../components/Header'
import HeroSection from '../components/HeroSection'
import ServicesSection from '../components/ServicesSection'
import SolutionsSection from '../components/SolutionsSection'
import BusinessSolutionsSection from '../components/BusinessSolutionsSection'
import ProjectsShowcaseCarousel from '../components/ProjectsShowcaseCarousel'
import AboutSection from '../components/AboutSection'
import TestimonialsSection from '../components/TestimonialsSection'
import BookingSection from '../components/BookingSection'
import ContactSection from '../components/ContactSection'
import Footer from '../components/Footer'

function HomePage() {
  console.log('HOME PAGE RENDERED', window.location.href, window.location.hash);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <div id="home">
          <HeroSection />
        </div>
        <div id="services">
          <ServicesSection />
        </div>
        <div id="solutions">
          <SolutionsSection />
        </div>
        <BusinessSolutionsSection />
        <ProjectsShowcaseCarousel />
        <div id="about">
          <AboutSection />
        </div>
        <TestimonialsSection />
        <div id="booking">
          <BookingSection />
        </div>
        <div id="contact">
          <ContactSection />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default HomePage